<!-- MainMenu.vue -->
<template>
  <!-- <el-aside style="height: 100%;"> -->
    <el-menu
      :show-timeout="100"
      router
      :default-openeds="getGlobalDefaultOpenedMenus()"
      :default-active="activeMenu"
      :collapse-transition="false"
      class="el-menu-vertical-demo"
      :collapse="props.iscollapse"
      unique-opened
      @open="handleOpen"
      @close="handleClose"
    >
      <MenuItem v-for="item in props.menus" :activeMenu="activeMenu" :key="item.path" :item="item" :order-badge="orderBadge" />
    </el-menu>
  <!-- </el-aside> -->
</template>

<script setup>
import { onMounted, ref } from 'vue';
import "./iconfont/iconfont.css"
import {
	getGlobalDefaultOpenedMenus,
	getGlobalDefaultActiveMenu,
} from "@/core/global-data"
import MenuItem from './MenuItem.vue'; // 引入菜单项组件
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useOrderBadge } from "@/hooks/index";

const { orderBadge } = useOrderBadge();

const props = defineProps({
  menus: {
    default: [],
    type: Array
  },
  iscollapse: {
    default: false,
    type: Boolean
  }
})

const route = useRoute()

const activeMenu = computed(() => {
  const currentRoute = getGlobalDefaultActiveMenu(); // 获取当前路由
  const activeMenuFromMeta = route.meta.activeMenu; // 获取 meta 中的 activeMenu 属性

  // 如果当前路由的 meta 中有 activeMenu 属性，返回它作为父级菜单路径(用于高亮显示)
  if (activeMenuFromMeta) {
    return activeMenuFromMeta;
  }
  return currentRoute
})

onMounted(() => {
  console.log(props.menus, 'menus')
})

const handleOpen = (index) => {
  console.log('Menu opened:', index);
};

const handleClose = (index) => {
  console.log('Menu closed:', index);
};
</script>

<style scoped lang="scss">
/* .el-menu-vertical-demo {
  width: 200px;
} */
</style>
